// eslint-disable-next-line
import React from "react";

const ConfirmationModal = ({ isOpen, message, onConfirm, onCancel }) => {
  if (!isOpen) return null; // Don't render the modal if it's not open

  return (
    <div className=" fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg md:w-96 p-6 w-[300px]">
        {/* Modal Header */}
        <div className="text-xl font-semibold text-gray-800 mb-4">
          Delete Product
        </div>

        {/* Modal Message */}
        <p className="text-gray-600 mb-6">{message}</p>

        {/* Modal Actions */}
        <div className="flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-700 transition"
          >
            delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
